import { reducer } from './reducer';
import { saga } from './sagas';
import * as selectors from './selectors';

export const connectivityModel = { saga, reducer, selectors };
